
import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sessionExpired, setSessionExpired] = useState(false);

  const TOKEN_LIFETIME = 60 * 60 * 1000; // 60 دقيقة
  let logoutTimer = null;

  const startAutoLogoutTimer = (remainingTime) => {
    if (logoutTimer) clearTimeout(logoutTimer);

    logoutTimer = setTimeout(() => {
      setSessionExpired(true);
      logout();
    }, remainingTime);
  };

  const login = (userData, token) => {
    const createdAt = Date.now();

    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("authToken", token);
    localStorage.setItem("tokenCreatedAt", createdAt);

    setUser(userData);
    setSessionExpired(false);

    startAutoLogoutTimer(TOKEN_LIFETIME);
    navigate("/", { replace: true });
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    localStorage.removeItem("tokenCreatedAt");

    navigate("/login", { replace: true });
  };

  // (اختياري) refresh token لو السيرفر بيدعمه
  const refreshToken = async () => {
    try {
      const response = await fetch("/auth/refresh", { method: "POST" });
      const newToken = await response.text();

      localStorage.setItem("authToken", newToken);
      localStorage.setItem("tokenCreatedAt", Date.now());

      startAutoLogoutTimer(TOKEN_LIFETIME);
      console.log("🔄 Token refreshed!");

    } catch (error) {
      logout();
    }
  };
  

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("authToken");
    const createdAt = localStorage.getItem("tokenCreatedAt");

    if (!storedUser || !token || !createdAt) {
      setLoading(false);
      return;
    }

    const elapsed = Date.now() - Number(createdAt);

    if (elapsed >= TOKEN_LIFETIME) {
      setSessionExpired(true);
      logout();
    } else {
      setUser(JSON.parse(storedUser));
      startAutoLogoutTimer(TOKEN_LIFETIME - elapsed);
    }

    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, sessionExpired }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
